<template>
  <div class="accordion">
    <button
      type="button"
      aria-label="expand"
      class="accordion__button"
      @click="toggleSlide($event)"
      v-html="headerText"
    >
      {{ headerText }}
    </button>
    <div class="accordion__panel">
      <slot>default content here</slot>
    </div>
  </div>
</template>


<script>
import $ from 'jquery';

export default {
  props: {
    headerText: String,
  },
  data() {
    return {};
  },
  methods: {
    toggleSlide(e) {
      // console.log($(e.target).parent().find('.accordion__panel'))
      $(e.target).parent().children('.accordion__panel').slideToggle('fast');
      $(e.target).toggleClass('active');
    },
  },
  mounted() {
    // ACCORDIONS
    const panel = $('.accordion__panel');
    panel.hide();
  },
};
</script>


<style lang="scss" scoped>
/*------------------------------------*\
  #CREATIVE CONCEPT PRIMARY COLOURS
\*------------------------------------*/
$burgundy: #5d0819;
$accordion-color: #666;
$teal: #8bc7cd;
$light-grey: #e7e7e7;

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/

/**
  * ACCORDION
  */

.accordion {
  &__document {
    display: block;
    margin: 2rem auto;
    max-width: 300px;
  }
}
.accordion__button {
  // background-color: $accordion-color;
  // color: #fff;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  transition: max-height 0.4s;
  border: 1px solid #cccccc;

  // Make full width *mobile only
  width: 100vw;
  position: relative;
  left: 50%;
  margin-left: -50vw;

  &:after {
    content: "\002B";
    color: #fff;
    font-weight: bold;
    float: right;
    margin-left: 5px;
  }
}
.accordion__panel {
  padding: 1em 15px;
  // background-color: #fff;
  transition: max-height 0.2s ease-out;
  margin-bottom: 0px;
  // border: 1px solid #eee;

  // Make full width *mobile only
  width: 100vw;
  position: relative;
  left: 50%;
  margin-left: -50vw;
}

.active:after {
  content: "\2212";
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 768px) {
  /**
  * ACCORDION
  */
  .accordion__button {
    // Make full width *mobile only
    width: 100%;
    position: relative;
    left: 0%;
    margin-left: 0vw;
  }

  .accordion__panel {
    // Make full width *mobile only
    width: 100%;
    position: relative;
    left: 0%;
    margin-left: 0vw;
    background-color: $light-grey;
  }
}
/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
